module.exports = __webpack_public_path__ + "static/media/IndicaCG.fa888dd6.png";